export default {
  computed: {
    computedData () {
      if (!this.summary) {
        return {
          totalAmount: '—',
          amountMonth: '—',
          amountPrevDate: '—',
          amountPrevMonth: '—',
          amountToday: '—'
        }
      }

      return this.summary
    },

    difference () {
      if (!this.summary) {
        return 0
      }

      let amountPrevDate = this.summary.amountPrevDate
      let amountToday = this.summary.amountToday

      if (amountToday === null) amountToday = 0
      if (amountPrevDate === null) amountPrevDate = 0

      return amountPrevDate > 0 ? Math.round(((amountToday - amountPrevDate) / amountPrevDate) * 100) : 0
    },

    computedClass () {
      if (this.difference > 0) {
        return 'text-color-green'
      }

      if (this.difference < 0) {
        return 'text-color-error'
      }

      return 'text-color-space'
    },

    computedArrow () {
      if (this.difference > 0) {
        return '↑'
      }

      if (this.difference < 0) {
        return '↓'
      }

      return null
    }
  }
}
